// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-data-rec-dec {
  grid-column-start: 1;
  grid-column-end: 6;
  border-bottom: 1px solid #d8d9ea;
}
.decision-management {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding-top: 20px;
}
.decision-management table {
  width: 99%;
}
.decision-management table th,
.decision-management table td {
  text-align: center;
}
.rrr {
  margin-top: 25px !important;
}
.link {
  color: #5484ff;
  cursor: pointer;
}
.change-property-decision-warn {
  background-color: white;
  border: 1px solid;
  padding: 20px;
  position: fixed;
  top: 45%;
  left: 51%;
  transform: translate(-50%, -50%);
  z-index: 500;
}
div.modal-overlay-decision-warn {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
}
.hard-decline-trigger-text {
  font-weight: 600;
  color: #dc3545;
  margin: 0 20px;
  font-size: 17px;
  display: inline-block;
  text-decoration: underline;
}
p.rec-dec-label {
  display: inline-block;
  font-size: 17px;
  font-weight: 500;
  padding: 0 6px;
}
.group-member {
  display: inline-block;
  padding-left: 15px;
}
.group-member p {
  padding-right: 15px;
}
.group-decision {
  justify-content: left;
}
.add-decline-button {
  color: #dc3545;
  margin-top: -5px;
  font-size: 25px !important;
}
.hard-decline-trigger-text {
  padding: 20px 0px;
  grid-column-start: 1;
  grid-column-end: 6;
  text-align: center;
}
.decline-reason-control {
  width: 100%;
}
.riq-display {
  float: right;
  font-weight: bolder;
  margin-right: 5px;
  padding-right: 9px;
  border-right: 1px solid;
}
.paint-it-green {
  color: #54a54e;
}
.paint-it-red {
  color: #dc3545;
}
.group-spacer {
  padding-right: 35px;
}
#recommendedDecisions {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/recommended-decision-mgr/recommended-decision-mgr.component.less"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,kBAAA;EACA,gCAAA;AADJ;AAGA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;AADJ;AANA;EASQ,UAAA;AAAR;AATA;;EAYY,kBAAA;AACZ;AAIA;EACI,2BAAA;AAFJ;AAMA;EACI,cAAA;EACA,eAAA;AAJJ;AAQA;EACI,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;AANJ;AASA;EACI,oCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAPJ;AAUA;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AARJ;AAWA;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATJ;AAYA;EACI,qBAAA;EACA,kBAAA;AAVJ;AAQA;EAIQ,mBAAA;AATR;AAYA;EACI,qBAAA;AAVJ;AAaA;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;AAXJ;AAcA;EACI,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAZJ;AAeA;EACI,WAAA;AAbJ;AAgBA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAdJ;AAiBA;EACI,cAAA;AAfJ;AAkBA;EACI,cAAA;AAhBJ;AAmBA;EACI,mBAAA;AAjBJ;AAoBA;EACI,YAAA;AAlBJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.table-data-rec-dec{\n    grid-column-start: 1;\n    grid-column-end: 6;\n    border-bottom: 1px solid #d8d9ea;\n}\n.decision-management{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid @h1-bottom;\n    padding-top: 20px;\n    table{\n        width: 99%;     \n        th, td{\n            // border: 1px solid;\n            text-align: center;\n        }\n    }\n}\n\n.rrr{\n    margin-top: 25px !important\n}\n\n\n.link {\n    color: @brblue;\n    cursor: pointer;\n}\n\n\n.change-property-decision-warn{\n    background-color: white;\n    border: 1px solid;\n    padding : 20px;\n    position: fixed;\n    top: 45%;\n    left: 51%;\n    transform: translate(-50%, -50%);\n    z-index: 500;\n}\n\ndiv.modal-overlay-decision-warn{\n    background-color: rgba(0,0,0,.6);\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    top:0;\n    left:0;\n    z-index: 50;\n}\n\n.hard-decline-trigger-text{\n    font-weight: 600;\n    color: #dc3545;\n    margin: 0 20px;\n    font-size: 17px;\n    display: inline-block;\n    text-decoration: underline;\n}\n\np.rec-dec-label{\n    display: inline-block;\n    font-size: 17px;\n    font-weight: 500;\n    padding: 0 6px;\n}\n\n.group-member {\n    display: inline-block;\n    padding-left: 15px;\n    p {\n        padding-right: 15px;\n    }\n}\n.group-decision {\n    justify-content: left;\n}\n\n.add-decline-button{\n    color: #dc3545;\n    margin-top: -5px;\n    font-size: 25px !important;\n}\n\n.hard-decline-trigger-text{\n    padding: 20px 0px;\n    grid-column-start: 1;\n    grid-column-end: 6;\n    text-align: center;\n}\n\n.decline-reason-control{\n    width: 100%;\n}\n\n.riq-display{\n    float:right;\n    font-weight: bolder;\n    margin-right:5px;\n    padding-right: 9px;\n    border-right: 1px solid;\n}\n\n.paint-it-green{\n    color: #54a54e;\n}\n\n.paint-it-red{\n    color: #dc3545;\n}\n\n.group-spacer {\n    padding-right: 35px;\n}\n\n#recommendedDecisions {\n    width: 200px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
